import type { CompanySettings, UpdateCompanySettingsData } from "../types/company";
import api from "./axios";

interface CompanySettingsResponse {
  data: {
    company: CompanySettings;
  };
}

export const getCompanySettingsApi = async (): Promise<CompanySettings> => {
  const response = await api.get<CompanySettingsResponse>("/api/v1/company");
  return response.data.data.company;
};

export const updateCompanySettingsApi = async (
  data: UpdateCompanySettingsData,
): Promise<CompanySettings> => {
  const response = await api.put<CompanySettingsResponse>("/api/v1/company", data);
  return response.data.data.company;
};
